var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTarget(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.107,
    height: 67.107,
    viewBox: "0 0 67.107 67.107",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dartboard",
    d: "M53.756,16.131l4.746.814,8.6-8.6L59.987,7.12,58.766,0l-8.6,8.6.814,4.746-2.067,2.067A29.495,29.495,0,1,0,51.69,18.2Zm2.418-7.979.407,2.373,2.373.407-1.793,1.793-2.373-.407-.407-2.373ZM55.052,37.615A25.56,25.56,0,1,1,12.337,18.683a25.511,25.511,0,0,1,33.775-.469L40.531,23.8a17.716,17.716,0,1,0,2.781,2.781l5.582-5.582a25.448,25.448,0,0,1,6.158,16.621Zm-11.8,0A13.776,13.776,0,1,1,37.73,26.6l-5.7,5.7a5.9,5.9,0,1,0,2.781,2.781l5.7-5.7a13.691,13.691,0,0,1,2.744,8.238Zm-11.8,0a1.966,1.966,0,1,1-1.966-1.966A1.968,1.968,0,0,1,31.458,37.615Z",
    fill: "#90205d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.408e4b8f.svg";
export { ForwardRef as ReactComponent };